window.$ = window.jQuery = require('jquery');

import 'jquery';
import VeeValidate from 'vee-validate';

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import AOS from 'aos'
import 'aos/dist/aos.css'

require("./assets/fonts/Feather/feather.css");
require("./assets/libs/jarallax/dist/jarallax.css");
require("./assets/libs/highlightjs/styles/vs2015.css");
require("./assets/libs/@fancyapps/fancybox/dist/jquery.fancybox.min.css");
require("./assets/css/theme.css");

require("./assets/libs/bootstrap/dist/js/bootstrap.bundle.min.js");
require("./assets/libs/@fancyapps/fancybox/dist/jquery.fancybox.min.js");

Vue.use(VeeValidate);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    created() {
        AOS.init()
    },
    render: h => h(App)
}).$mount('#app');
